interface ContactType {
  name?: string | any;
  fullName?: string | any;
  simplifiedName?: string | any;
}

export const getContactName = (contact: ContactType) => {
  if (typeof contact?.simplifiedName === 'string') {
    return contact.simplifiedName;
  }
  if (typeof contact?.name === 'string') {
    return contact.name;
  }
  if (typeof contact?.fullName === 'string') {
    return contact.fullName;
  }

  return 'N/A';
};
